module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-container"
  }, [_c('div', {
    staticClass: "tags-box",
    class: {
      'tags-box--close': !_vm.website.isFirstPage
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "closable": _vm.tagLen !== 1
    },
    on: {
      "tab-click": _vm.openTag,
      "edit": _vm.menuTag
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.tagList), function(item) {
    return _c('el-tab-pane', {
      key: item.value,
      attrs: {
        "label": item.label,
        "name": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "tags-menu pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("\n        更多\n        "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeOthersTags.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭其他")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeAllTags.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭全部")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-150d7cdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/index/tags.vue
// module id = +ERp
// module chunks = 5